import { CART_ADD_ITEM, 
    CART_REMOVE_ITEM, 
    CART_SAVE_PAYMENT_METHOD, 
    CART_SAVE_SHIPPING_ADDRESS, 
    CART_SET_ITEMS } from "../Constants/cartConstants";
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { firestore, firebaseAuth } from "../firebase" 

export const addToCart = (productId, qty) => async(dispatch, getState) =>{
    
    const docRef = doc(firestore, 'PRODUCTS', productId);
    const docSnap = await getDoc(docRef);
            let data;
            if(docSnap.exists()){
                data= docSnap.data();
                dispatch({ 
                    type: CART_ADD_ITEM, 
                    payload: {
                        // Use the requested productId (doc data may not contain id field)
                        product: productId,
                        product_title:data.product_title ,
                        category:data.category,
                        subcategory: data.subCategory || data.subcategory,
                        product_image_1: data.product_image_1,
                        product_price: data.product_price,
                        cutted_price: data.cutted_price,
                        seller_id: data.seller_id,
                        stock_quantity:data.stock_quantity,
                        brand: data.brand,
                        max_quantity:data.max_quantity,
                        min_quantity:data.min_quantity || 1,
                        average_rating: data.average_rating,
                        // Commission percentage from product info (used at order time)
                        commission: data.commission || data.commissionInPercentage || data.Commission || 5.0,
                        total_ratings: data.total_ratings,
                        product_description: data.product_description,
                        COD: (typeof data.COD === 'boolean' ? data.COD : !!data.cod_available),
                        // Variants for DeliveryScreen selectors
                        available_sizes: Array.isArray(data.available_sizes)
                            ? data.available_sizes
                            : (Array.isArray(data.available_size) ? data.available_size : undefined),
                        available_colors: Array.isArray(data.available_colors)
                            ? data.available_colors
                            : (Array.isArray(data.availableColors) ? data.availableColors : undefined),
                        qty,
                    }

                })
            }
            // persist locally
            localStorage.setItem('cartItems',JSON.stringify(getState().cart.cartItems));
            // persist to Firestore if user signed in
            try{
                const state = getState();
                const uid = state?.userSignin?.userInfo?.uid || firebaseAuth.currentUser?.uid;
                if (uid){
                    const items = state.cart.cartItems || [];
                    const payload = { list_size: items.length };
                    items.forEach((it, idx) => {
                        payload[`product_ID_${idx}`] = it.product;
                    });
                    const cartDocRef = doc(firestore, 'USERS', uid, 'USER_DATA', 'MY_CART');
                    // overwrite to avoid stale fields from previous larger lists
                    await setDoc(cartDocRef, payload, { merge: false });
                }
            }catch(e){
                // ignore persistence errors for UX
                console.error('Persist cart failed:', e);
            }
};

export const removeFromCart =(productId) => (dispatch, getState) =>{
    dispatch({type: CART_REMOVE_ITEM,payload: productId});
    const stateAfter = getState();
    localStorage.setItem('cartItems', JSON.stringify(stateAfter.cart.cartItems));
    // persist to Firestore if user signed in
    (async () => {
        try{
            const uid = stateAfter?.userSignin?.userInfo?.uid || firebaseAuth.currentUser?.uid;
            if (uid){
                const items = stateAfter.cart.cartItems || [];
                const payload = { list_size: items.length };
                items.forEach((it, idx) => {
                    payload[`product_ID_${idx}`] = it.product;
                });
                const cartDocRef = doc(firestore, 'USERS', uid, 'USER_DATA', 'MY_CART');
                // overwrite to avoid stale fields
                await setDoc(cartDocRef, payload, { merge: false });
            }
        }catch(e){
            console.error('Persist cart failed:', e);
        }
    })();
};

export const saveShippingAddress = (data) => (dispatch) =>{
    dispatch({type: CART_SAVE_SHIPPING_ADDRESS,payload: data});
    localStorage.setItem('shippingAddress',JSON.stringify(data));
};

export const savePaymentMethod = (data) => (dispatch) => {
    dispatch({type:CART_SAVE_PAYMENT_METHOD, payload:data})
    try {
        localStorage.setItem('paymentMethod', JSON.stringify(data));
    } catch (_) {}
};

export const loadCartFromFirestore = () => async (dispatch, getState) => {
    try{
        const state = getState();
        const uid = state?.userSignin?.userInfo?.uid || firebaseAuth.currentUser?.uid;
        if (!uid){
            return;
        }
        
        // Get current local cart items
        const currentCartItems = state.cart.cartItems || [];
        
        const cartDocRef = doc(firestore, 'USERS', uid, 'USER_DATA', 'MY_CART');
        const snap = await getDoc(cartDocRef);
        if (!snap.exists()){
            // If no Firestore cart exists, keep current local cart and sync it to Firestore
            if (currentCartItems.length > 0) {
                console.log('No Firestore cart found, syncing local cart to Firestore');
                const payload = { list_size: currentCartItems.length };
                currentCartItems.forEach((item, idx) => {
                    payload[`product_ID_${idx}`] = item.product;
                });
                await setDoc(cartDocRef, payload, { merge: false });
            }
            return; // Keep current cart as is
        }
        const d = snap.data() || {};
        const size = Number(d.list_size) || 0;
        const items = [];
        for (let i = 0; i < size; i++){
            const pid = d[`product_ID_${i}`];
            const qty = 1; // default to 1; quantities are not persisted in Firestore
            if (!pid) continue;
            const pRef = doc(firestore, 'PRODUCTS', pid);
            const pSnap = await getDoc(pRef);
            if (pSnap.exists()){
                const data = pSnap.data();
                items.push({
                    product: data.id,
                    product_title: data.product_title,
                    category: data.category,
                    subcategory: data.subCategory || data.subcategory,
                    product_image_1: data.product_image_1,
                    product_price: data.product_price,
                    cutted_price: data.cutted_price,
                    seller_id: data.seller_id,
                    stock_quantity: data.stock_quantity,
                    brand: data.brand,
                    max_quantity: data.max_quantity,
                    min_quantity: data.min_quantity || 1,
                    average_rating: data.average_rating,
                    // Include commission if available; default to 5.0
                    commission: data.commission || data.commissionInPercentage || data.Commission || 5.0,
                    // Variants for DeliveryScreen selectors
                    available_sizes: Array.isArray(data.available_sizes)
                        ? data.available_sizes
                        : (Array.isArray(data.available_size) ? data.available_size : undefined),
                    available_colors: Array.isArray(data.available_colors)
                        ? data.available_colors
                        : (Array.isArray(data.availableColors) ? data.availableColors : undefined),
                    total_ratings: data.total_ratings,
                    product_description: data.product_description,
                    qty,
                });
            }
        }
        
        // Merge Firestore cart with current local cart
        const mergedItems = [...items];
        currentCartItems.forEach(localItem => {
            // Check if this item is already in Firestore cart
            const existsInFirestore = items.some(firestoreItem => 
                firestoreItem.product === localItem.product
            );
            if (!existsInFirestore) {
                console.log('Adding local cart item to merged cart:', localItem.product_title);
                mergedItems.push(localItem);
            }
        });
        
        dispatch({ type: CART_SET_ITEMS, payload: mergedItems });
        localStorage.setItem('cartItems', JSON.stringify(mergedItems));
        
        // Update Firestore with merged cart
        if (mergedItems.length !== items.length) {
            console.log('Syncing merged cart back to Firestore');
            const payload = { list_size: mergedItems.length };
            mergedItems.forEach((item, idx) => {
                payload[`product_ID_${idx}`] = item.product;
            });
            await setDoc(cartDocRef, payload, { merge: false });
        }
    }catch(e){
        console.error('Load cart from Firestore failed:', e);
    }
};
